import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-ic_search",
  "use": "icon-ic_search-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 21 21\" id=\"icon-ic_search\">\n  <path fill-rule=\"evenodd\" stroke=\"rgb(221, 221, 221)\" stroke-width=\"1px\" stroke-linecap=\"butt\" stroke-linejoin=\"miter\" fill=\"none\" d=\"M8.000,0.500 C12.142,0.500 15.500,3.858 15.500,8.000 C15.500,12.142 12.142,15.500 8.000,15.500 C3.858,15.500 0.500,12.142 0.500,8.000 C0.500,3.858 3.858,0.500 8.000,0.500 Z\" />\n  <path fill-rule=\"evenodd\" fill=\"rgb(221, 221, 221)\" d=\"M13.212,13.963 L13.919,13.256 L19.575,18.912 L18.868,19.620 L13.212,13.963 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/admin/icons/svg/ic_search.svg
// module id = iXjC
// module chunks = 8